<template>
    <div class="content">
        <table class="table">
            <thead>
                <tr>
                    <th v-t="'creation.file_filename'" />
                    <th v-t="'creation.file_size'" />
                    <th />
                </tr>
            </thead>
            <tbody>
                <tr v-for="(file, index) in files" :key="index">
                    <th>{{ file.name }}</th>
                    <td>{{ file.size | formatBytes }}</td>
                    <td>
                        <div class="buttons has-addons">
                            <a
                                class="button is-danger"
                                @click="removeFile(file)"
                            >
                                <span class="icon is-small">
                                    <i class="fas fa-trash" />
                                </span>
                            </a>
                            <!--a 
                  class="button" 
         
                >
                  <span class="icon is-small">
                    <i class="fas fa-italic"/>
                  </span>
                </a>
                <a 
                  class="button" 
                >
                  <span class="icon is-small">
                    <i class="fas fa-underline"/>
                  </span>
                </a-->
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
        <div class="file is-centered">
            <label class="file-label">
                <input
                    class="file-input"
                    type="file"
                    multiple="true"
                    @change="handleFile"
                />
                <span class="file-cta">
                    <span v-t="'creation.select_file'" class="file-label" />
                </span>
            </label>
        </div>
    </div>
</template>

<script>
import { upload } from '@/services/API';
import { without } from 'underscore';
export default {
    name: 'InputFile',
    filters: {
        formatBytes(bytes, decimals = 2) {
            if (bytes === 0) return '0 Bytes';

            const k = 1024;
            const dm = decimals < 0 ? 0 : decimals;
            const sizes = [
                'Bytes',
                'KB',
                'MB',
                'GB',
                'TB',
                'PB',
                'EB',
                'ZB',
                'YB',
            ];

            const i = Math.floor(Math.log(bytes) / Math.log(k));

            return (
                parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) +
                ' ' +
                sizes[i]
            );
        },
    },
    model: {
        prop: 'sourceFiles',
    },
    props: { sourceFiles: { type: Array, default: () => [] } },
    data() {
        return {
            files: this.sourceFiles,
        };
    },
    methods: {
        async handleFile(ev) {
            if (ev.target.files.length == 0) {
                return;
            }
            this.$emit('uploading');
            let response = await upload(`files`, ev.target.files).catch(
                (err) => {
                    return this.$emit('error', err);
                }
            );
            if (response.data) {
                this.files = [...this.files, ...response.data.files];
                this.$emit('input', this.files);
            }
        },
        removeFile(file) {
            this.files = without(this.files, file);
            this.$emit('input', this.files);
        },
    },
};
</script>

<style></style>
